module.exports = __webpack_public_path__ + "img/quaro_final_white.6c90e804.svg";